// extracted by mini-css-extract-plugin
module.exports = {"tierAnimation":"Ticket_tierAnimation__0FLFw","highlight":"Ticket_highlight__c6VmP"};